const getPageDataParent8w = () => {
  // The 'page-data' folder is at root, ex: www.8thwall.com/page-data/index/page-data.json'
  return ''
}

module.exports = {
  getPageDataParent8w,
}
